import React, { useContext } from 'react';

import RetailerContext from '../context';

import CanadaBeefLogo from '../shared/svg/CanadaBeefLogo.svg';

import { Box } from '@mui/material';

import '../styles/Logo.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { getTranslation } from '../utils/translate';
import { useSelector } from 'react-redux';

const Logo = ({ style = {} }) => {
  const { retailer } = useContext(RetailerContext);
  const language = useSelector(state => state.language);
  const translatedRetailer = getTranslation(retailer, { key: 'languages_code', code: language.code });

  let logo = CanadaBeefLogo;

  if (retailer.logo.id) {
    logo = `${process.env.REACT_APP_API_URL}/assets/${retailer.logo.id}?key=brand-logo`;
  }

  if (translatedRetailer?.logo) {
    logo = `${process.env.REACT_APP_API_URL}/assets/${translatedRetailer?.logo}?key=brand-logo`;
  }

  return (
    <Link
      to="/"
    >
      <Box
        className="logo_info"
        sx={{}}
      >
        <img
          src={logo}
          alt="img"
          className="logo_img"
          style={{
            zIndex: 1,
            position: "relative",
            ...style
          }}
        />
      </Box>
    </Link>
  );
};

export default Logo;
